<script>
import MyReviewMixin from '@/mixins/my_review'
import MyReviewTable from '@/components/MyReviewTable'

export default {
  name: 'MyReview',
  mixins: [MyReviewMixin],
  props: {
    activeTab: { type: String, default: '' },
    formType: { type: String, default: 'my_review_new' }
  },
  data() {
    return {
      reviewTable: {
        formType: 'my_review_new'
      },
      snModalTitle: ''
    }
  },
  components: {
    MyReviewTable
  },
  methods: {
    myEmailsFormSubmit(data) {
      this.reviewTable.formType = 'my_review_subscriptions'
      this.buildRequestMessage(data, 'myEmailsFormEdit')
      if (this.requestMessage == '') {
        alert('No subscription change requested')
        return
      }
      this.snModalTitle = 'Update Email List Subscriptions Request Submitted'
      this.requestSubject = 'Update Email List Subscriptions'
      this.graphql(this.sendEmailMutation, {
        to: process.env.VUE_APP_SUPPORT_EMAIL,
        subject: this.requestSubject,
        message: this.requestMessage
      })
      this.$bvModal.show('sn-request-submitted')
    },
    newUserFormSubmit(data) {
      this.reviewTable.formType = 'my_review_new'
      if (!data.newPersonId && !data.name) {
        alert('You must enter a new user')
        return
      }
      this.buildRequestMessage(data)
      this.snModalTitle = 'New ARM Staff Request Submitted'
      this.requestSubject = `${data.updateType} - ${
        data.username && data.username != '' ? data.username : data.name
      }`
      this.graphql(this.sendEmailMutation, {
        to: process.env.VUE_APP_STAFF_EMAIL,
        subject: this.requestSubject,
        message: this.requestMessage
      })
      this.$bvModal.show('sn-request-submitted')
    },
    fieldValueChanged(fieldName, newValue, extras) {
      if (fieldName == 'groupRecords') {
        if (extras.record.selected && extras.record.associatedEmails) {
          let emails = extras.record.associatedEmails.split(/, /g)
          let activeEmailRecords = this.$refs.formEdit.$refs.form.formData
            .activeEmailRecords
          for (let email of emails) {
            if (activeEmailRecords.find(record => record.emailList == email)) {
              activeEmailRecords.find(
                record => record.emailList == email
              ).selected = true
            }
          }
          //console.log(activeEmailRecords)
          this.$set(this.$refs.formEdit, 'formData', {
            ...this.$refs.formEdit.$refs.form.formData,
            activeEmailRecords
          })
        }
      }
    }
  }
}
</script>

<template>
  <div>
    <GraphQLFormEdit
      formType="my_review"
      :recordId="myPersonId"
      :activeTab="activeTab"
      editRecordRoute="myReview"
      editRecordTabRoute="myReviewTab"
      :key="myPersonId"
    >
      <template v-slot:JoinTable(myEmailLists)="joinTable">
        <GraphQLFormEdit
          formType="my_review_subscriptions"
          :recordId="myPersonId"
          :submitTriggerInsteadOfSave="true"
          @submitForm="myEmailsFormSubmit"
          ref="myEmailsFormEdit"
        />
      </template>
      <template v-slot:JoinTable(groupOwnerActive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(emailOwnerActive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(emailOwnerInactive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(newArmStaff)="joinTable">
        <GraphQLFormEdit
          formType="my_review_new"
          :recordId="myPersonId"
          :submitTriggerInsteadOfSave="true"
          @submitForm="newUserFormSubmit"
          @fieldValueChanged="fieldValueChanged"
          ref="formEdit"
        />
      </template>
    </GraphQLFormEdit>
    <b-modal
      id="sn-request-submitted"
      :title="snModalTitle"
      size="xl"
      scrollable
      centered
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <b-row>
        <b-col cols="2" class="font-weight-bold">Subject:</b-col>
        <b-col>{{ requestSubject }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="2" class="font-weight-bold">
          Message:
        </b-col>
        <b-col>
          <pre>{{ requestMessage }}</pre>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
